import { getCMSConfig } from '../cms';
import { formatTariffDetails } from '../formatter';
import { PreMarketingType } from '../../enums/product';
import { JarvisProduct } from '@vfde-sails/avc-core';

export const getNotAvailableHeadline = (preMarketingType?: PreMarketingType) => preMarketingType
    ? (() => {
        switch (preMarketingType) {
            case PreMarketingType.BHS:
                return getCMSConfig()?.offerSummaryCard?.preMarketing.homesPassedBHS.headline;
            case PreMarketingType.BKV:
                return getCMSConfig()?.offerSummaryCard?.preMarketing.homesPassedBKV.headline;
            case PreMarketingType.PRE_FIBER:
                return getCMSConfig()?.offerSummaryCard?.preMarketing.preFiber.headline;
        }
    })()
    : getCMSConfig()?.offerSummaryCard?.notAvailable.headline || '';

export const getPriceSubline = (tariff?: JarvisProduct, preMarketingType?: PreMarketingType) => {
    if (preMarketingType) {
        switch (preMarketingType) {
            case PreMarketingType.BHS:
                return getCMSConfig()?.offerSummaryCard?.preMarketing.homesPassedBHS.subline;
            case PreMarketingType.BKV:
                return getCMSConfig()?.offerSummaryCard?.preMarketing.homesPassedBKV.subline;
            case PreMarketingType.PRE_FIBER:
                return getCMSConfig()?.offerSummaryCard?.preMarketing.preFiber.subline;
        }
    }

    return tariff
        ? formatTariffDetails(tariff.download, tariff.upload)
        : getCMSConfig()?.offerSummaryCard?.notAvailable.subline || '';
};
